module.exports = __webpack_public_path__ + "img/icon_m_covert.f35c1b5e.svg";